import { render, staticRenderFns } from "./cotinine-cot-rapid-test_h5.vue?vue&type=template&id=e5f2e01c&scoped=true&"
import script from "./cotinine-cot-rapid-test_h5.vue?vue&type=script&lang=js&"
export * from "./cotinine-cot-rapid-test_h5.vue?vue&type=script&lang=js&"
import style0 from "./cotinine-cot-rapid-test_h5.vue?vue&type=style&index=0&id=e5f2e01c&scoped=true&lang=less&"
import style1 from "./cotinine-cot-rapid-test_h5.vue?vue&type=style&index=1&id=e5f2e01c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f2e01c",
  null
  
)

export default component.exports